import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-coe-login-page',
  templateUrl: './coe-login-page.component.html',
  styleUrls: ['./coe-login-page.component.css'],
})
export class CoeLoginPageComponent implements OnInit {
  partnerregisterForm: FormGroup;
  private registerApi = environment.url + environment.register;
  /**
   * Initializes the COE login page component.
   * Creates a form group with the required fields and sets the visibility of the component to true.
   * @param router The Angular router service.
   * @param fb The Angular form builder service.
   * @param makeapi The API service.
   * @param getdata The value service.
   * @param notify The notification service.
   */
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService
  ) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    /**
     * The form group for the COE login page.
     * Contains the following fields: name, phone, email, and roleid.
     */
    this.partnerregisterForm = this.fb.group({
      /**
       * The name of the COE.
       */
      name: ['', [Validators.required]],
      /**
       * The phone number of the COE.
       * Must be a valid phone number with the following pattern: \\+91-? or 0?[0-9]{10}.
       */
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      /**
       * The email address of the COE.
       * Must be a valid email address with the following pattern: [a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}.
       */
      email: ['', [Validators.required, Validators.pattern(emailPattern)]],
      /**
       * The role ID of the COE.
       * Must be 7.
       */
      roleid: [7],
    });
  }
  get add() {
    return this.partnerregisterForm.controls;
  }
  /**
   * Initializer for the COE login page component.
   * Sets the visibility of the component to true and checks the registration status for COE.
   */
  ngOnInit(): void {
    // Set the visibility of the component to true
    this.getdata.isVisibleSource.next(true);

    // Check the registration status for COE
    this.checkRegistrationStatusCoE();
  }

  /**
   * Handles the registration process for a partner admin.
   * Validates the form, shows a loading indicator, and sends a registration request.
   * Displays a modal on successful registration or shows an error notification if failed.
   */
  registerpartnerAdmin() {
    // Get the form values
    let getform = this.partnerregisterForm.value;

    // Check if the form is invalid
    if (this.partnerregisterForm.invalid) {
      // Mark all fields as touched to show validation errors
      this.partnerregisterForm.markAllAsTouched();
      // Notify the user to fill all mandatory fields
      this.notify.notifyError('Please fill all the mandatory fields !!');
      return;
    } else {
      // Show a loading indicator
      this.getdata.amizhthLoader('show');

      // Send registration request
      this.makeapi
        .method(this.registerApi, getform, 'login')
        .subscribe((data) => {
          // Hide the loading indicator
          this.getdata.amizhthLoader('hide');

          // Check the response status
          if (data.responseStatus == 'Success') {
            // Display the registration success modal
            document.getElementById('coeModal').style.display = 'block';
          } else {
            // Notify the user of the error message from the response
            this.notify.notifyError(data.responseMessage);
          }
        });
    }
  }
  /**
   * Cancels the registration form and navigates to the home page.
   */
  cancelReg() {
    // Reset the form
    this.partnerregisterForm.reset();
    // Navigate to the home page
    this.router.navigateByUrl('/home');
  }
  /**
   * Closes the modal dialog box and navigates to the login page.
   * @description This function is called when the close button is clicked on the modal dialog box.
   * It navigates to the login page and closes the modal dialog box.
   */
  closeModal(): void {
    // Navigate to the login page
    this.router.navigateByUrl('/login');
    // Close the modal dialog box
    document.getElementById('coeModal').style.display = 'none';
  }
  isRegistrationClosedCoE: boolean = false;
  /**
   * Checks if the registration is closed
   * @description Checks if the current date is after the registration deadline
   */
  checkRegistrationStatusCoE(): void {
    const deadline = new Date(2026, 2, 4, 11, 30, 0); // 21st February 2025, 12:00 AM
    const now = new Date();
    this.isRegistrationClosedCoE = now >= deadline;
  }
}
